/**
 * @generated SignedSource<<f266b5334483a4f982cea8e3ad38d5a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceRoutineEditSectionSettingsQuery$variables = {
  workspaceId: string;
};
export type WorkspaceRoutineEditSectionSettingsQuery$data = {
  readonly workspace: {
    readonly topics: ReadonlyArray<{
      readonly id: string;
      readonly isPrivate: boolean;
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"RoutineEditMainOrgTopicListItem_topics">;
    }> | null;
  };
};
export type WorkspaceRoutineEditSectionSettingsQuery = {
  response: WorkspaceRoutineEditSectionSettingsQuery$data;
  variables: WorkspaceRoutineEditSectionSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceRoutineEditSectionSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OrgTopic",
            "kind": "LinkedField",
            "name": "topics",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "RoutineEditMainOrgTopicListItem_topics"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceRoutineEditSectionSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OrgTopic",
            "kind": "LinkedField",
            "name": "topics",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0d355a47a6af1d4a7178c204165de665",
    "id": null,
    "metadata": {},
    "name": "WorkspaceRoutineEditSectionSettingsQuery",
    "operationKind": "query",
    "text": "query WorkspaceRoutineEditSectionSettingsQuery(\n  $workspaceId: ID!\n) {\n  workspace(id: $workspaceId) {\n    topics {\n      id\n      name\n      isPrivate\n      ...RoutineEditMainOrgTopicListItem_topics\n    }\n    id\n  }\n}\n\nfragment RoutineEditMainOrgTopicListItemSelector_topics on OrgTopic {\n  id\n  name\n  description\n}\n\nfragment RoutineEditMainOrgTopicListItem_topics on OrgTopic {\n  __typename\n  ...RoutineEditMainOrgTopicListItemSelector_topics\n}\n"
  }
};
})();

(node as any).hash = "629d7b0e2d6e574438328b8fed0d2301";

export default node;
